import { render, staticRenderFns } from "./ExpenseIndex.vue?vue&type=template&id=37bcece4&"
import script from "./ExpenseIndex.vue?vue&type=script&lang=js&"
export * from "./ExpenseIndex.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseIndex.vue?vue&type=style&index=0&id=37bcece4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports